import { useState, useEffect, useRef } from "react";

/* ─── Google Fonts ─────────────────────────────────────────────────────────── */
const FONT_LINK = `https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;0,900;1,400;1,600&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&display=swap`;

/* ─── DATA ──────────────────────────────────────────────────────────────────── */
const INFRA_SLIDES = [
  {
    category: "Home Infrastructure",
    title: "Home to Beautiful Interiors",
    desc: "Transform your space with PR Hospital Designers' expert designers — crafted for how you truly live.",
    stats: [["100K+", "Homes Designed"], ["60+", "Cities"], ["45 Days", "Delivery"]],
    cta: "Book Free Consultation",
    img: "https://images.livspace-cdn.com/w:1440/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/homepage/banner-1714034487-xNaST/desktop-1777023769-NzTuC.png",
  },
  {
    category: "Home Infrastructure",
    title: "Know Your Kitchen Cost Instantly",
    desc: "Use our smart price calculator for accurate estimates before you begin.",
    stats: [["500+", "Design Templates"], ["10 Yr", "Warranty"], ["98%", "Satisfaction"]],
    cta: "Calculate Now",
    img: "https://images.livspace-cdn.com/w:1440/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/homepage/v2-1675654701-1kKSt/desktop-1675655000-6H0mD/banner-1675655465-eXung/kitchen-homepage-banner-web-1689683306-uyQOf.jpg",
  },
  {
    category: "Hospital Infrastructure",
    title: "Healthcare Spaces Built for Healing",
    desc: "We design clinical environments that prioritise patient well-being and operational efficiency.",
    stats: [["200+", "Hospitals Built"], ["ISO", "Certified"], ["24/7", "Project Support"]],
    cta: "Explore Hospital Projects",
    img: "https://images.livspace-cdn.com/w:1440/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/homepage/banner-1714034487-xNaST/home-desktop-1776762070-OcRy1.png",
  },
  {
    category: "Hospital Infrastructure",
    title: "India's First Lifetime Warranty",
    desc: "Quality assurance you can trust — backed by PR Hospital Designers for every project we deliver.",
    stats: [["50+", "ICU Projects"], ["NABH", "Compliant"], ["30+", "Years Experience"]],
    cta: "Book Free Consultation",
    img: "https://images.livspace-cdn.com/w:1440/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/homepage/banner-1714034487-xNaST/home-desktop-1776762070-OcRy1.png",
  },
];

const OFFERINGS = [
  { title: "Modular Interiors", subtitle: "Functional kitchen, wardrobe and storage", img: "https://images.livspace-cdn.com/w:320/h:234/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/offerings-interiors-1682066909-GMFDK/modular-1-1682066917-W5NcL.jpg" },
  { title: "Full Home Interiors", subtitle: "Turnkey interior solutions for your home", img: "https://images.livspace-cdn.com/w:320/h:234/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/offerings-interiors-1682066909-GMFDK/full-home-1682066987-lk16r.jpg" },
  { title: "Luxury Interiors", subtitle: "Tailored interiors that redefine elegance", img: "https://images.livspace-cdn.com/w:320/h:234/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/offerings-interiors-1682066909-GMFDK/vinviago-desk-1692618545-ToZjR.jpg" },
  { title: "Renovations", subtitle: "Expert solutions to upgrade your home", img: "https://images.livspace-cdn.com/w:320/h:234/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/offerings-interiors-1682066909-GMFDK/reno-1682066988-lqJkS.jpg" },
];

const DESIGN_STORIES = [
  { label: "Living Room", landscape: true, img: "https://images.livspace-cdn.com/w:700/h:394/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/interior-designer-near-me-1668702759-oSI2D/design-stories-1668705027-Hz88h/desktop-1668705032-723a7/new-folder-1689150183-B8fsX/living-room-d-1689150613-oIGOU.jpg" },
  { label: "Master Bedroom", landscape: false, img: "https://images.livspace-cdn.com/w:282/h:394/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/interior-designer-near-me-1668702759-oSI2D/design-stories-1668705027-Hz88h/desktop-1668705032-723a7/new-folder-1689150183-B8fsX/master-bedroom-d-1689150615-GAvUx.jpg" },
  { label: "False Ceiling", landscape: false, img: "https://images.livspace-cdn.com/w:282/h:394/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/interior-designer-near-me-1668702759-oSI2D/design-stories-1668705027-Hz88h/desktop-1668705032-723a7/new-folder-1689150183-B8fsX/false-ceiling-designs-web-1694434017-5JzRp.jpg" },
  { label: "Kitchen", landscape: true, img: "https://images.livspace-cdn.com/w:700/h:394/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/interior-designer-near-me-1668702759-oSI2D/design-stories-1668705027-Hz88h/desktop-1668705032-723a7/new-folder-1689150183-B8fsX/kitchen-d-1689150612-ouirR.jpg" },
  { label: "Wardrobe", landscape: false, img: "https://images.livspace-cdn.com/w:282/h:394/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/interior-designer-near-me-1668702759-oSI2D/design-stories-1668705027-Hz88h/desktop-1668705032-723a7/new-folder-1689150183-B8fsX/wardrobe-d-1689150619-VfOcJ.jpg" },
  { label: "Dining Room", landscape: true, img: "https://images.livspace-cdn.com/w:700/h:394/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/interior-designer-near-me-1668702759-oSI2D/design-stories-1668705027-Hz88h/desktop-1668705032-723a7/new-folder-1689150183-B8fsX/dining-room-d-1689150498-HC3VH.jpg" },
];

const WHY_CHOOSE = [
  { icon: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/city-page/year-warranty-1775824886-iq5EB.png", title: "Lifetime Warranty¹" },
  { icon: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/why-choose-us-1682067952-gXbOw/45-day-move-in-guarantee-1682070434-vYtgS.jpg", title: "45-Day Move-In" },
  { icon: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/why-choose-us-1682067952-gXbOw/146-quality-checks-1682070435-krIlQ.jpg", title: "146 Quality Checks" },
  { icon: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/why-choose-us-1682067952-gXbOw/50000-happy-homes-1682070435-ih1Ir.jpg", title: "1,00,000+ Homes" },
  { icon: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/why-choose-us-1682067952-gXbOw/40-cities-1682070433-M7Q2t.jpg", title: "100+ Cities" },
  { icon: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/why-choose-us-1682067952-gXbOw/20-lakhcatalogue-products-1682070432-CoDEa.jpg", title: "20L+ Products" },
  { icon: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/why-choose-us-1682067952-gXbOw/3500-designers-1682070430-eEvZq.jpg", title: "2,000+ Designers" },
];

const CALCULATORS = [
  { title: "Full Home Interior", desc: "Know the estimate price for your full home interiors", iconL: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/price-estimator-1682068031-6FLQd/full-hi-1682068037-mSqKH.jpg", iconR: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/mobile-1664858443-m6vo0/price-estimators-1682069788-xGgFt/calculator-1682069838-tZQ4E.webp" },
  { title: "Kitchen", desc: "Get an approximate costing for your kitchen interior", iconL: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/mobile-1664858443-m6vo0/price-estimators-1682069788-xGgFt/kitchen-copy-1682069840-cnYX7.webp", iconR: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/mobile-1664858443-m6vo0/price-estimators-1682069788-xGgFt/calculator-1682069838-tZQ4E.webp" },
  { title: "Wardrobe", desc: "Our estimate for your dream wardrobe", iconL: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/price-estimator-1682068031-6FLQd/wardrobe-1-1682068117-6oLvL.jpg", iconR: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/mobile-1664858443-m6vo0/price-estimators-1682069788-xGgFt/calculator-1682069838-tZQ4E.webp" },
];

const TESTIMONIALS = [
  { name: "Rohit Paul & Shveta", location: "Gurugram", review: "Hats off to the entire team at PR Hospital Designers. They finished the project ahead of time.", img: "https://images.livspace-cdn.com/w:400/h:194/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/mobile-1664858443-m6vo0/testimonials-1682062695-HIjkJ/rohit-paula-1682062954-3pnjQ.jpg" },
  { name: "Swati & Gaurav", location: "Bangalore", review: "Our experience with PR Hospital Designers was outstanding, thanks to the dedicated project managers.", img: "https://images.livspace-cdn.com/w:400/h:194/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/mobile-1664858443-m6vo0/testimonials-1682062695-HIjkJ/swati-gaurav-1682063290-MSkUW.jpg" },
  { name: "Puja Bhatia", location: "Gurugram", review: "We reached out to PR Hospital Designers and they designed exactly the home we always dreamed of.", img: "https://images.livspace-cdn.com/w:400/h:194/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/mobile-1664858443-m6vo0/testimonials-1682062695-HIjkJ/puja-bhatia-1682063289-aTyu6.jpg" },
];

const HOMES_GALLERY = [
  { title: "Modern 4 BHK Penthouse", city: "Bangalore", img: "https://images.livspace-cdn.com/w:500/h:466/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/livspace-homes-1682068198-shXmv/modern-4-bhk-penthouse-home-design-in-bangalore-1682068280-rncG1.jpg" },
  { title: "Contemporary 4 BHK Penthouse", city: "Noida", img: "https://images.livspace-cdn.com/w:500/h:466/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/livspace-homes-1682068198-shXmv/contemporary-house-design-for-4-bhk-penthouse-in-noida-1682068280-0eOO7.jpg" },
  { title: "Elegant 2 BHK Flat", city: "Mumbai", img: "https://images.livspace-cdn.com/w:500/h:466/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/livspace-homes-1682068198-shXmv/modern-house-design-for-2-bhk-flat-in-mumbai-1682068281-ab4gr.jpg" },
  { title: "Contemporary 3 BHK House", city: "Gurgaon", img: "https://images.livspace-cdn.com/w:500/h:466/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/livspace-homes-1682068198-shXmv/contemporary-3-bhk-house-design-in-gurgaon-1682068277-e8xQN.jpg" },
  { title: "Rustic 3 BHK Home", city: "Bangalore", img: "https://images.livspace-cdn.com/w:500/h:466/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/livspace-homes-1682068198-shXmv/rustic-house-design-for-3-bhk-flat-in-bangalore-1682068282-lbPWM.jpg" },
];

const MAGAZINE_POSTS = [
  { title: "50+ Bedroom Colours: Single Shades and Combinations for Every Style", author: "Harsha Shankar", date: "April 14, 2026", img: "https://images.livspace-cdn.com/w:400/plain/https://jumanji.livspace-cdn.com/magazine/wp-content/uploads/sites/2/2023/03/18124700/bedroom-wall-colour-combination.jpg" },
  { title: "15+ Marble Pooja Room Designs That Can Add a WOW Factor to Your Home", author: "Editorial Team", date: "April 10, 2026", img: "https://images.livspace-cdn.com/w:400/plain/https://jumanji.livspace-cdn.com/magazine/wp-content/uploads/sites/2/2023/01/22114341/marble-mandir-designs-for-indian-homes-1.jpg" },
  { title: "PVC Kitchen Cabinets: Moisture-Resistant, Termite-Proof & Modular", author: "PR Hospital Designers Editorial Team", date: "March 06, 2026", img: "https://images.livspace-cdn.com/w:400/plain/https://jumanji.livspace-cdn.com/magazine/wp-content/uploads/sites/2/2025/07/08145325/pvc-kitchen-cabinets-2026-scaled.jpg" },
];

const TROPHIES = [
  { name: "India's Most Trusted Brand", img: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/homepage/trophy-cabinet-1632932655-dSKZy/desktop-1632932664-wvWdu/v2-1684213832-QUMTD/best-interior-design-d-v1-1684213851-BVio3.jpg" },
  { name: "Best Interior Design Solutions Brand", img: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/homepage/trophy-cabinet-1632932655-dSKZy/desktop-1632932664-wvWdu/v2-1684213832-QUMTD/gbn-d-v1-1684213854-rLyzH.jpg" },
  { name: "Innovative Start-up", img: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/homepage/trophy-cabinet-1632932655-dSKZy/desktop-1632932664-wvWdu/v2-1684213832-QUMTD/entrpreneur-d-v1-1684213852-njoNT.jpg" },
  { name: "World's Most Innovative Company", img: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/homepage/trophy-cabinet-1632932655-dSKZy/desktop-1632932664-wvWdu/v2-1684213832-QUMTD/fast-company-d-v1-1684213853-vvCJK.jpg" },
  { name: "Top 100 Global Companies", img: "https://images.livspace-cdn.com/w:80/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/homepage/trophy-cabinet-1632932655-dSKZy/desktop-1632932664-wvWdu/v2-1684213832-QUMTD/red-herring-d-v1-1684213855-oTyFz.jpg" },
];

const NEWS_LOGOS = [
  { name: "Bloomberg", img: "https://images.livspace-cdn.com/w:302/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/in-the-news-1682401419-J61vw/bloomberg-1682401474-ArUs1.jpg" },
  { name: "Business Today", img: "https://images.livspace-cdn.com/w:302/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/in-the-news-1682401419-J61vw/business-today-1682401475-Lsiod.jpg" },
  { name: "CNBC", img: "https://images.livspace-cdn.com/w:302/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/in-the-news-1682401419-J61vw/cnbc-1682401476-zldSU.jpg" },
  { name: "Entrepreneur", img: "https://images.livspace-cdn.com/w:302/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/in-the-news-1682401419-J61vw/entrpreneur-1682677467-7QjOd.jpg" },
  { name: "Economic Times", img: "https://images.livspace-cdn.com/w:302/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/in-the-news-1682401419-J61vw/et-1682401477-NjRCA.jpg" },
  { name: "Femina", img: "https://images.livspace-cdn.com/w:302/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/in-the-news-1682401419-J61vw/femina-1682401478-VMDBI.jpg" },
  { name: "GQ", img: "https://images.livspace-cdn.com/w:302/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/in-the-news-1682401419-J61vw/gq-1682401480-K5jcJ.jpg" },
  { name: "India Today", img: "https://images.livspace-cdn.com/w:302/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/in-the-news-1682401419-J61vw/india-today-home-1682401481-kqBb2.jpg" },
  { name: "Mint", img: "https://images.livspace-cdn.com/w:302/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/in-the-news-1682401419-J61vw/mint-1682401482-d0I7g.jpg" },
  { name: "Times of India", img: "https://images.livspace-cdn.com/w:302/h:80/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/in/unification-home-1663681501-pVo75/desktop-1663681517-hulYi/in-the-news-1682401419-J61vw/toi-1682401483-unoIf.jpg" },
];

const FAQS = [
  { q: "1. Why do I need an interior designer?", a: "Think of an interior designer as a film director — they monitor every detail from concept to completion. At PR Hospital Designers, our designers understand your needs and tastes to deliver your dream home, from raw materials to finished products." },
  { q: "2. Why is PR Hospital Designers perfect for your home interior design?", a: "PR Hospital Designers is the perfect partner to build your home interiors just the way you want! Our design experts customize designs as per your needs, incorporating advanced technology into modular solutions for flawless results." },
  { q: "3. What services are included under home interior design?", a: "PR Hospital Designers is a one-stop destination — design, delivery, installation, modular interiors, false ceilings, civil work, painting, electrical work, plumbing, flooring, and tiling." },
  { q: "4. How much does home interiors cost?", a: "1 BHK: Starting at ₹3.62L | 2 BHK: Starting at ₹4.52L | 3 BHK: Starting at ₹5.57L | 4 BHK: Starting at ₹6.33L | Modular Kitchens: Starting at ₹1.7L." },
  { q: "5. What will be the timelines for my project completion?", a: "We deliver a 45-day Move-in Guarantee for modular solutions. Full home interiors take 90 days. Timelines may vary based on material availability, approvals, and site readiness." },
  { q: "6. What are the trending interior design styles?", a: "Top styles include: Bohemian, Modern, Colonial, Indian Traditional, Art Deco, Industrial, Minimalist, and Scandinavian — all available through PR Hospital Designers." },
];

/* ─── INLINE STYLES ─────────────────────────────────────────────────────────── */
const S = {
  page: { fontFamily:"'Poppins', sans-serif", background: "#fff", color: "#111", overflowX: "hidden" },
  sliderWrap: { position: "relative", width: "100%", height: "92vh", minHeight: 520, overflow: "hidden", background: "#111" },
  sliderTrack: (active) => ({ display: "flex", alignItems: "flex-start", height: "110%", transform: `translateX(-${active * 100}%)`, transition: "transform 0.7s cubic-bezier(0.77,0,0.175,1)" }),
  sliderSlide: { minWidth: "100%", width: "100%", height: "100%", position: "relative", flexShrink: 0 },
  sliderImg: { width: "100%", height: "100%", objectFit: "cover", filter: "brightness(0.40)" },
  sliderGrad: { position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(0,0,0,0.80) 0%, rgba(0,0,0,0.25) 55%, transparent 100%)" },
  sliderContent: { position: "absolute", inset: 0, display: "flex", flexDirection: "column", justifyContent: "flex-end", padding: "0 72px 96px" },
  sliderCat: { display: "inline-flex", alignItems: "center", gap: 8, marginBottom: 16, fontFamily: "'Poppins', sans-serif", fontSize: 11, letterSpacing: 3, textTransform: "uppercase", color: "#d4af37", fontWeight: 700 },
  sliderDot: { width: 6, height: 6, borderRadius: "50%", background: "#d4af37" },
  sliderTitle: { fontFamily: "'Poppins', sans-serif", fontSize: "clamp(34px,5vw,62px)", fontWeight: 700, color: "#fff", lineHeight: 1.1, maxWidth: 680, marginBottom: 16 },
  sliderDesc: { fontSize: 15, color: "rgba(255,255,255,0.70)", maxWidth: 480, lineHeight: 1.8, marginBottom: 28 },
  sliderStats: { display: "flex", gap: 40, marginBottom: 32 },
  sliderStat: { borderLeft: "2px solid #d4af37", paddingLeft: 14 },
  sliderStatNum: { fontFamily: "'Poppins', sans-serif", fontSize: 26, fontWeight: 700, color: "#fff", lineHeight: 1 },
  sliderStatLabel: { fontSize: 10, letterSpacing: 1.5, textTransform: "uppercase", color: "rgba(255,255,255,0.50)", marginTop: 3 },
  sliderCta: { display: "inline-flex", alignItems: "center", gap: 10, background: "transparent", border: "1px solid rgba(255,255,255,0.40)", color: "#fff", padding: "13px 28px", fontSize: 12, letterSpacing: 2, textTransform: "uppercase", cursor: "pointer", fontFamily: "'Poppins', sans-serif", fontWeight: 600, width: "fit-content", transition: "all 0.3s" },
  sliderCounter: { position: "absolute", top: 28, right: 72, fontFamily: "'Poppins', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.45)", zIndex: 10, letterSpacing: 2 },
  sliderArrows: { position: "absolute", bottom: 80, right: 72, display: "flex", gap: 10, zIndex: 10 },
  sliderArrow: { width: 46, height: 46, border: "1px solid rgba(255,255,255,0.25)", background: "rgba(0,0,0,0.40)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 20, cursor: "pointer", transition: "all 0.25s" },
  sliderDots: { position: "absolute", bottom: 36, left: "50%", transform: "translateX(-50%)", display: "flex", gap: 8, zIndex: 10 },
  sliderDotEl: (active) => ({ height: 2, width: active ? 38 : 18, background: active ? "#d4af37" : "rgba(255,255,255,0.30)", cursor: "pointer", transition: "all 0.4s" }),
  sliderProgress: (w) => ({ position: "absolute", bottom: 0, left: 0, height: 3, background: "#d4af37", zIndex: 10, width: `${w}%`, transition: "width 0.1s linear" }),
  section: (bg = "#fff") => ({ padding: "72px 0", background: bg }),
  inner: { maxWidth: 1280, margin: "0 auto", padding: "0 24px" },
  sectionHead: (center = false) => ({ marginBottom: 44, textAlign: center ? "center" : "left" }),
  sectionTag: { fontSize: 11, letterSpacing: 3, textTransform: "uppercase", color: "#888", fontWeight: 700, display: "block", marginBottom: 10 },
  sectionTitle: { fontFamily:"'Poppins', sans-serif", fontSize: "clamp(26px,4vw,42px)", fontWeight: 700, color: "#111", lineHeight: 1.2 },
  sectionSub: { fontSize: 15, color: "#666", marginTop: 10, maxWidth: 560, lineHeight: 1.7 },
  viewAllBtn: { marginTop: 12, background: "none", border: "none", cursor: "pointer", fontFamily: "'Poppins', sans-serif", fontSize: 13, color: "#111", fontWeight: 700, display: "flex", alignItems: "center", gap: 6 },
  offeringGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(250px,1fr))", gap: 20 },
  offeringCard: (hov) => ({ borderRadius: 20, overflow: "hidden", cursor: "pointer", border: "1px solid #e8e8e8", transition: "all 0.3s", transform: hov ? "translateY(-8px)" : "translateY(0)", boxShadow: hov ? "0 20px 52px rgba(0,0,0,0.13)" : "0 2px 10px rgba(0,0,0,0.04)" }),
  offeringImg: { width: "100%", height: 200, objectFit: "cover" },
  offeringBody: { padding: "18px 20px 20px", background: "#fff" },
  offeringTitle: { fontFamily: "'Poppins', sans-serif", fontSize: 16, fontWeight: 600, color: "#111", marginBottom: 6 },
  offeringSub: { fontSize: 12, color: "#777", lineHeight: 1.5, marginBottom: 14 },
  offeringArrow: { width: 34, height: 34, background: "#111", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 16 },
  storiesTrack: { display: "flex", gap: 12, overflowX: "auto", paddingBottom: 8, scrollbarWidth: "thin" },
  storyCard: (landscape) => ({ position: "relative", borderRadius: 16, overflow: "hidden", flexShrink: 0, width: landscape ? 320 : 180, height: 220, cursor: "pointer" }),
  storyImg: { width: "100%", height: "100%", objectFit: "cover" },
  storyGrad: { position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(0,0,0,0.65) 0%, transparent 60%)" },
  storyLabel: { position: "absolute", bottom: 10, left: 10, background: "rgba(0,0,0,0.55)", backdropFilter: "blur(6px)", borderRadius: 7, padding: "4px 10px", fontSize: 11, fontWeight: 700, color: "#fff" },
  marqueeWrap: { overflow: "hidden", position: "relative" },
  marqueeInner: (x) => ({ display: "flex", gap: 20, width: "max-content", transform: `translateX(${x}px)` }),
  whyCard: { background: "#fff", border: "1px solid #eee", borderRadius: 18, padding: "24px 20px", textAlign: "center", width: 170, flexShrink: 0, boxShadow: "0 4px 16px rgba(0,0,0,0.05)" },
  whyIcon: { width: 64, height: 64, borderRadius: 12, objectFit: "cover", marginBottom: 10 },
  whyTitle: { fontSize: 12, fontWeight: 700, color: "#111" },
  calcHeader: { textAlign: "center", marginBottom: 40 },
  calcHeadRow: { display: "flex", alignItems: "center", justifyContent: "center", gap: 10, flexWrap: "wrap" },
  calcHeadText: { fontFamily: "'Poppins', sans-serif", fontSize: "clamp(22px,4vw,38px)", fontWeight: 700, color: "#111" },
  calcHeadAnimated: { fontFamily: "'Poppins', sans-serif", fontSize: "clamp(22px,4vw,38px)", fontWeight: 700, color: "#111", borderBottom: "3px solid #111", paddingBottom: 2 },
  calcGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 20 },
  calcCard: (hov) => ({ background: "#fff", borderRadius: 18, padding: 24, border: hov ? "2px solid #111" : "2px solid #eee", transition: "all 0.3s", transform: hov ? "translateY(-4px)" : "translateY(0)", boxShadow: hov ? "0 14px 42px rgba(0,0,0,0.10)" : "0 4px 14px rgba(0,0,0,0.04)" }),
  calcIcons: { display: "flex", justifyContent: "space-between", marginBottom: 18 },
  calcIconL: { width: 56, height: 56, borderRadius: 12, objectFit: "cover" },
  calcIconR: { width: 40, height: 40, borderRadius: 10, objectFit: "cover" },
  calcCardTitle: { fontFamily: "'Poppins', sans-serif", fontSize: 18, fontWeight: 600, color: "#111", marginBottom: 6 },
  calcCardDesc: { fontSize: 12, color: "#777", lineHeight: 1.5, marginBottom: 18 },
  calcBtn: { background: "#111", color: "#fff", border: "none", borderRadius: 10, padding: "11px 22px", fontSize: 12, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 },
  midBanner: { padding: "0 24px 72px", background: "#f8f8f8" },
  midBannerInner: { maxWidth: 1280, margin: "0 auto", borderRadius: 22, overflow: "hidden", background: "linear-gradient(135deg,#111 0%,#2a2a2a 100%)", padding: "56px 48px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 32, flexWrap: "wrap" },
  midBannerTag: { fontSize: 11, fontWeight: 700, color: "#888", letterSpacing: 2, textTransform: "uppercase", marginBottom: 12, fontFamily: "'Poppins', sans-serif" },
  midBannerTitle: { fontFamily: "'Poppins', sans-serif", fontSize: "clamp(26px,4vw,44px)", fontWeight: 700, color: "#fff", lineHeight: 1.2 },
  midBannerSub: { fontFamily: "'Poppins', sans-serif", color: "#999", marginTop: 10, maxWidth: 380, fontSize: 14 },
  midBannerBtn: { background: "#fff", color: "#111", border: "none", borderRadius: 12, padding: "16px 36px", fontFamily: "'Poppins', sans-serif", fontSize: 14, fontWeight: 700, cursor: "pointer", flexShrink: 0, transition: "all 0.3s" },
  testiGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 24 },
  testiCard: (hov) => ({ background: "#fff", borderRadius: 18, overflow: "hidden", border: "1px solid #eee", boxShadow: hov ? "0 18px 52px rgba(0,0,0,0.12)" : "0 4px 20px rgba(0,0,0,0.06)", transition: "all 0.3s", transform: hov ? "translateY(-6px)" : "translateY(0)" }),
  testiImgWrap: { position: "relative" },
  testiImg: { width: "100%", height: 175, objectFit: "cover" },
  testiImgGrad: { position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(0,0,0,0.55), transparent)" },
  testiImgMeta: { position: "absolute", bottom: 10, left: 0, right: 0, textAlign: "center" },
  testiName: { fontFamily: "'Poppins', sans-serif", fontSize: 13, fontWeight: 700, color: "#fff" },
  testiLoc: { fontFamily: "'Poppins', sans-serif", fontSize: 11, color: "rgba(255,255,255,0.80)" },
  testiBody: { padding: "20px 22px", position: "relative" },
  testiQuote: { fontSize: 44, color: "#e8e8e8", fontFamily: "'Poppins', sans-serif", lineHeight: 1, position: "absolute", top: 10, left: 18 },
  testiText: { fontFamily: "'Poppins', sans-serif", fontSize: 13, color: "#555", lineHeight: 1.75, fontStyle: "italic", paddingTop: 6 },
  galleryTrack: { display: "flex", gap: 16, overflowX: "auto", paddingBottom: 8, scrollbarWidth: "thin" },
  galleryCard: (hov) => ({ position: "relative", borderRadius: 18, overflow: "hidden", flexShrink: 0, width: 252, height: 340, cursor: "pointer", transition: "transform 0.3s", transform: hov ? "scale(1.03)" : "scale(1)" }),
  galleryImg: { width: "100%", height: "100%", objectFit: "cover" },
  galleryGrad: { position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(0,0,0,0.72) 0%, transparent 50%)" },
  galleryMeta: { position: "absolute", bottom: 14, left: 14, right: 14 },
  galleryTitle: { fontFamily: "'Poppins', sans-serif", fontSize: 13, fontWeight: 600, color: "#fff", lineHeight: 1.4 },
  galleryCity: { fontFamily: "'Poppins', sans-serif", fontSize: 11, color: "rgba(255,255,255,0.72)", marginTop: 3 },
  galleryCtaRow: { textAlign: "center", marginTop: 36 },
  galleryCtaBtn: { background: "#111", color: "#fff", border: "none", borderRadius: 12, padding: "14px 36px", fontFamily: "'Poppins', sans-serif", fontSize: 13, fontWeight: 700, cursor: "pointer", transition: "all 0.3s" },
  magGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 28 },
  magCard: { cursor: "pointer" },
  magImgWrap: { borderRadius: 14, overflow: "hidden", marginBottom: 14 },
  magImg: { width: "100%", height: 195, objectFit: "cover", transition: "transform 0.4s" },
  magTitle: { fontFamily: "'Poppins', sans-serif", fontSize: 16, fontWeight: 600, color: "#111", lineHeight: 1.4, marginBottom: 7 },
  magMeta: { fontFamily: "'Poppins', sans-serif", fontSize: 11, color: "#999", fontStyle: "italic" },
  trophyGrid: { display: "flex", gap: 18, flexWrap: "wrap", justifyContent: "center" },
  trophyCard: (hov) => ({ background: "#fff", borderRadius: 18, padding: "22px 28px", display: "flex", flexDirection: "column", alignItems: "center", gap: 12, border: "1px solid #eee", minWidth: 190, textAlign: "center", transition: "all 0.3s", transform: hov ? "translateY(-6px)" : "translateY(0)", boxShadow: hov ? "0 18px 52px rgba(0,0,0,0.10)" : "none" }),
  trophyImg: { width: 72, height: 72, objectFit: "contain", borderRadius: 10 },
  trophyName: { fontFamily: "'Poppins', sans-serif", fontSize: 11, fontWeight: 700, color: "#333", lineHeight: 1.4 },
  newsWrap: { overflow: "hidden" },
  newsTrack: (x) => ({ display: "flex", gap: 22, width: "max-content", transform: `translateX(${x}px)` }),
  newsCard: { background: "#f8f8f8", borderRadius: 10, border: "1px solid #eee", flexShrink: 0, height: 72, display: "flex", alignItems: "center", justifyContent: "center" },
  newsImg: { height: 72, maxWidth: 200, objectFit: "contain" },
  faqList: { maxWidth: 820, margin: "0 auto" },
  faqItem: (open) => ({ background: "#fff", borderRadius: 14, marginBottom: 10, border: "1px solid #eee", overflow: "hidden", boxShadow: open ? "0 6px 24px rgba(0,0,0,0.08)" : "none", transition: "box-shadow 0.3s" }),
  faqBtn: { width: "100%", background: "none", border: "none", cursor: "pointer", padding: "18px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", textAlign: "left", gap: 14, fontFamily: "'Poppins', sans-serif", fontSize: 14, fontWeight: 600, color: "#111" },
  faqPlus: (open) => ({ fontSize: 20, color: "#111", flexShrink: 0, display: "inline-block", transition: "transform 0.3s", transform: open ? "rotate(45deg)" : "rotate(0)" }),
  faqAns: { padding: "0 22px 18px", fontFamily: "'Poppins', sans-serif", fontSize: 13, color: "#666", lineHeight: 1.8 },
  dreamBanner: { background: "linear-gradient(135deg,#111 0%,#2d2d2d 50%,#1a1a1a 100%)", padding: "80px 24px", textAlign: "center", position: "relative", overflow: "hidden" },
  dreamBannerDots: { position: "absolute", inset: 0, opacity: 0.05, backgroundImage: "radial-gradient(circle at 50% 50%, #fff 1px, transparent 1px)", backgroundSize: "40px 40px" },
  dreamBannerTitle: { fontFamily: "'Poppins', sans-serif", fontSize: "clamp(30px,5vw,54px)", fontWeight: 700, color: "#fff", marginBottom: 14, lineHeight: 1.2, position: "relative" },
  dreamBannerSub: { fontFamily: "'Poppins', sans-serif", color: "rgba(255,255,255,0.60)", fontSize: 15, marginBottom: 38, maxWidth: 460, margin: "0 auto 38px", position: "relative" },
  dreamBannerBtn: { background: "#fff", color: "#111", border: "none", borderRadius: 12, padding: "18px 52px", fontFamily: "'Poppins', sans-serif", fontSize: 15, fontWeight: 800, cursor: "pointer", letterSpacing: 0.5, transition: "all 0.3s", textTransform: "uppercase", position: "relative" },
};

/* ─── REUSABLE SECTION WRAPPER ───────────────────────────────────────────────── */
function Section({ title, tag, subtitle, cta, children, bg = "#fff", center = false }) {
  return (
    <section style={S.section(bg)}>
      <div style={S.inner}>
        {(title || tag) && (
          <div style={S.sectionHead(center)}>
            {tag && <span style={S.sectionTag}>{tag}</span>}
            {title && <h2 style={S.sectionTitle}>{title}</h2>}
            {subtitle && <p style={S.sectionSub}>{subtitle}</p>}
            {cta && <button style={S.viewAllBtn}>{cta} →</button>}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}

/* ─── HERO SLIDER ───────────────────────────────────────────────────────────── */
function HeroSlider() {
  const [active, setActive] = useState(0);
  const [progress, setProgress] = useState(0);
  const progressRef = useRef(null);

  const startAuto = () => {
    setProgress(0);
    let p = 0;
    clearInterval(progressRef.current);
    progressRef.current = setInterval(() => {
      p += 0.2;
      setProgress(p);
      if (p >= 100) {
        clearInterval(progressRef.current);
        setActive((prev) => (prev + 1) % INFRA_SLIDES.length);
      }
    }, 10);
  };

  useEffect(() => { startAuto(); return () => clearInterval(progressRef.current); }, [active]);

  const goTo = (i) => { clearInterval(progressRef.current); setActive(i); };

  return (
    <div style={S.sliderWrap}>
      <div style={S.sliderTrack(active)}>
        {INFRA_SLIDES.map((sl, i) => (
          <div key={i} style={S.sliderSlide}>
            <img src={sl.img} alt={sl.title} style={S.sliderImg} />
            <div style={S.sliderGrad} />
            <div style={S.sliderContent}>
              <div style={S.sliderCat}><span style={S.sliderDot} />{sl.category}</div>
              <h2 style={S.sliderTitle}>{sl.title}</h2>
              <p style={S.sliderDesc}>{sl.desc}</p>
              <div style={S.sliderStats}>
                {sl.stats.map(([n, l]) => (
                  <div key={l} style={S.sliderStat}>
                    <div style={S.sliderStatNum}>{n}</div>
                    <div style={S.sliderStatLabel}>{l}</div>
                  </div>
                ))}
              </div>
              <button style={S.sliderCta}
                onMouseEnter={e => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.color = "#111"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#fff"; }}>
                {sl.cta} →
              </button>
            </div>
          </div>
        ))}
      </div>
      <div style={S.sliderCounter}>
        <span style={{ color: "#fff", fontSize: 19 }}>{String(active + 1).padStart(2, "0")}</span> / {String(INFRA_SLIDES.length).padStart(2, "0")}
      </div>
      <div style={S.sliderArrows}>
        {[{ label: "‹", fn: () => goTo((active - 1 + INFRA_SLIDES.length) % INFRA_SLIDES.length) }, { label: "›", fn: () => goTo((active + 1) % INFRA_SLIDES.length) }].map(({ label, fn }) => (
          <button key={label} style={S.sliderArrow} onClick={fn}
            onMouseEnter={e => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.color = "#111"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "rgba(0,0,0,0.40)"; e.currentTarget.style.color = "#fff"; }}>
            {label}
          </button>
        ))}
      </div>
      <div style={S.sliderDots}>
        {INFRA_SLIDES.map((_, i) => (
          <div key={i} style={S.sliderDotEl(i === active)} onClick={() => goTo(i)} />
        ))}
      </div>
      <div style={S.sliderProgress(progress)} />
    </div>
  );
}

function OneStopShop() {
  const [hov, setHov] = useState(null);
  return (
    <Section title="One-stop shop for all things interiors" subtitle="Be it end-to-end interiors, renovation or modular solutions, we have it all for your home or office.">
      <div style={S.offeringGrid}>
        {OFFERINGS.map((o, i) => (
          <div key={i} style={S.offeringCard(hov === i)} onMouseEnter={() => setHov(i)} onMouseLeave={() => setHov(null)}>
            <img src={o.img} alt={o.title} style={S.offeringImg} />
            <div style={S.offeringBody}>
              <div style={S.offeringTitle}>{o.title}</div>
              <div style={S.offeringSub}>{o.subtitle}</div>
              <div style={S.offeringArrow}>›</div>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}

function DesignInspirations() {
  return (
    <Section title="Inspiration for home interior designs" subtitle="Give your home a new look with these interior design ideas curated for you" cta="View All" bg="#f8f8f8">
      <div style={S.storiesTrack}>
        {DESIGN_STORIES.map((s, i) => (
          <div key={i} style={S.storyCard(s.landscape)}>
            <img src={s.img} alt={s.label} style={S.storyImg} />
            <div style={S.storyGrad} />
            <div style={S.storyLabel}>{s.label}</div>
          </div>
        ))}
      </div>
    </Section>
  );
}

function WhyChooseUs() {
  const [x, setX] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setX(p => p - 1), 20);
    return () => clearInterval(t);
  }, []);
  const looped = [...WHY_CHOOSE, ...WHY_CHOOSE, ...WHY_CHOOSE];
  const totalW = WHY_CHOOSE.length * 210;
  return (
    <Section title="Why choose us" center>
      <div style={S.marqueeWrap}>
        <div style={S.marqueeInner(x % totalW === 0 && x < 0 ? x + totalW : x)}>
          {looped.map((w, i) => (
            <div key={i} style={S.whyCard}>
              <img src={w.icon} alt={w.title} style={S.whyIcon} />
              <div style={S.whyTitle}>{w.title}</div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

function PriceCalculators() {
  const [hov, setHov] = useState(null);
  const [spin, setSpin] = useState(0);
  const labels = ["Kitchen", "Wardrobe", "Full Home"];
  useEffect(() => {
    const t = setInterval(() => setSpin(s => (s + 1) % 3), 2000);
    return () => clearInterval(t);
  }, []);
  return (
    <Section bg="#f8f8f8">
      <div style={S.calcHeader}>
        <div style={S.calcHeadRow}>
          <h2 style={S.calcHeadText}>Get the estimate for your</h2>
          <span style={S.calcHeadAnimated}>{labels[spin]}</span>
        </div>
        <p style={{ ...S.sectionSub, margin: "12px auto 0", textAlign: "center" }}>Calculate the approximate cost of doing up your home interiors</p>
      </div>
      <div style={S.calcGrid}>
        {CALCULATORS.map((c, i) => (
          <div key={i} style={S.calcCard(hov === i)} onMouseEnter={() => setHov(i)} onMouseLeave={() => setHov(null)}>
            <div style={S.calcIcons}>
              <img src={c.iconL} alt="" style={S.calcIconL} />
              <img src={c.iconR} alt="" style={S.calcIconR} />
            </div>
            <div style={S.calcCardTitle}>{c.title}</div>
            <div style={S.calcCardDesc}>{c.desc}</div>
            <button style={S.calcBtn}>Calculate ›</button>
          </div>
        ))}
      </div>
    </Section>
  );
}

function MidBanner() {
  return (
    <div style={S.midBanner}>
      <div style={S.midBannerInner}>
        <div>
          <div style={S.midBannerTag}>Once you buy, we never say goodbye</div>
          <h2 style={S.midBannerTitle}>Lifetime warranty on all our products</h2>
          <p style={S.midBannerSub}>India's first lifetime warranty — because your home deserves the best, forever.</p>
        </div>
        <button style={S.midBannerBtn}
          onMouseEnter={e => { e.target.style.transform = "translateY(-3px)"; e.target.style.boxShadow = "0 10px 36px rgba(0,0,0,0.28)"; }}
          onMouseLeave={e => { e.target.style.transform = "translateY(0)"; e.target.style.boxShadow = "none"; }}>
          Book Free Consultation
        </button>
      </div>
    </div>
  );
}

function Testimonials() {
  const [hov, setHov] = useState(null);
  return (
    <Section title="Check out some of our customer reviews" cta="View More">
      <div style={S.testiGrid}>
        {TESTIMONIALS.map((t, i) => (
          <div key={i} style={S.testiCard(hov === i)} onMouseEnter={() => setHov(i)} onMouseLeave={() => setHov(null)}>
            <div style={S.testiImgWrap}>
              <img src={t.img} alt={t.name} style={S.testiImg} />
              <div style={S.testiImgGrad} />
              <div style={S.testiImgMeta}>
                <div style={S.testiName}>{t.name}</div>
                <div style={S.testiLoc}>{t.location}</div>
              </div>
            </div>
            <div style={S.testiBody}>
              <div style={S.testiQuote}>"</div>
              <p style={S.testiText}>{t.review}</p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}

function HomesGallery() {
  const [hov, setHov] = useState(null);
  return (
    <Section title="Get a glimpse of PR Hospital Designers homes" subtitle="Latest dream home interiors delivered the hassle-free way" bg="#f8f8f8">
      <div style={S.galleryTrack}>
        {HOMES_GALLERY.map((h, i) => (
          <div key={i} style={S.galleryCard(hov === i)} onMouseEnter={() => setHov(i)} onMouseLeave={() => setHov(null)}>
            <img src={h.img} alt={h.title} style={S.galleryImg} />
            <div style={S.galleryGrad} />
            <div style={S.galleryMeta}>
              <div style={S.galleryTitle}>{h.title}</div>
              <div style={S.galleryCity}>{h.city}</div>
            </div>
          </div>
        ))}
      </div>
      <div style={S.galleryCtaRow}>
        <button style={S.galleryCtaBtn}
          onMouseEnter={e => { e.target.style.background = "#333"; e.target.style.transform = "translateY(-2px)"; }}
          onMouseLeave={e => { e.target.style.background = "#111"; e.target.style.transform = "translateY(0)"; }}>
          GET FREE QUOTE
        </button>
      </div>
    </Section>
  );
}

function Magazine() {
  const [hov, setHov] = useState(null);
  return (
    <Section title="Stay updated with trending home interior designs!" subtitle="Find everything from design fixes to expert tips on PR Hospital Designers magazine" cta="See more">
      <div style={S.magGrid}>
        {MAGAZINE_POSTS.map((p, i) => (
          <div key={i} style={S.magCard} onMouseEnter={() => setHov(i)} onMouseLeave={() => setHov(null)}>
            <div style={S.magImgWrap}>
              <img src={p.img} alt={p.title} style={{ ...S.magImg, transform: hov === i ? "scale(1.05)" : "scale(1)" }} />
            </div>
            <h3 style={S.magTitle}>{p.title}</h3>
            <p style={S.magMeta}>{p.author} | {p.date}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}

function TrophyCabinet() {
  const [hov, setHov] = useState(null);
  return (
    <Section title="Our trophy cabinet" bg="#f8f8f8" center>
      <div style={S.trophyGrid}>
        {TROPHIES.map((t, i) => (
          <div key={i} style={S.trophyCard(hov === i)} onMouseEnter={() => setHov(i)} onMouseLeave={() => setHov(null)}>
            <img src={t.img} alt={t.name} style={S.trophyImg} />
            <p style={S.trophyName}>{t.name}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}

function InTheNews() {
  const [x, setX] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setX(p => p - 0.6), 16);
    return () => clearInterval(t);
  }, []);
  const looped = [...NEWS_LOGOS, ...NEWS_LOGOS, ...NEWS_LOGOS];
  const totalW = NEWS_LOGOS.length * 220;
  return (
    <Section title="In the news">
      <div style={S.newsWrap}>
        <div style={S.newsTrack(x % totalW === 0 && x < 0 ? x + totalW : x)}>
          {looped.map((n, i) => (
            <div key={i} style={S.newsCard}>
              <img src={n.img} alt={n.name} style={S.newsImg} />
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

function FAQSection() {
  const [open, setOpen] = useState(null);
  return (
    <Section title="FAQs About Home Interior Design" bg="#f8f8f8">
      <div style={S.faqList}>
        {FAQS.map((f, i) => (
          <div key={i} style={S.faqItem(open === i)}>
            <button style={S.faqBtn} onClick={() => setOpen(open === i ? null : i)}>
              <span>{f.q}</span>
              <span style={S.faqPlus(open === i)}>+</span>
            </button>
            {open === i && <div style={S.faqAns}>{f.a}</div>}
          </div>
        ))}
      </div>
    </Section>
  );
}

function DreamBanner() {
  return (
    <div style={S.dreamBanner}>
      <div style={S.dreamBannerDots} />
      <h2 style={S.dreamBannerTitle}>Your dream home is just a click away</h2>
      <p style={S.dreamBannerSub}>Let PR Hospital Designers' expert designers transform your space into something extraordinary.</p>
      <button style={S.dreamBannerBtn}
        onMouseEnter={e => { e.target.style.transform = "translateY(-4px)"; e.target.style.boxShadow = "0 18px 52px rgba(255,255,255,0.18)"; }}
        onMouseLeave={e => { e.target.style.transform = "translateY(0)"; e.target.style.boxShadow = "none"; }}>
        GET STARTED
      </button>
    </div>
  );
}

/* ─── MAIN EXPORT ───────────────────────────────────────────────────────────── */
export default function Home() {
  return (
    <div style={S.page}>
      <style>{`
        @import url('${FONT_LINK}');
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { width: 5px; height: 5px; }
        ::-webkit-scrollbar-track { background: #f1f1f1; }
        ::-webkit-scrollbar-thumb { background: #ccc; border-radius: 100px; }
        ::-webkit-scrollbar-thumb:hover { background: #999; }
        img { display: block; }
        html { scroll-behavior: smooth; }
      `}</style>

      <HeroSlider />
      <OneStopShop />
      <DesignInspirations />
      <WhyChooseUs />
      <PriceCalculators />
      <MidBanner />
      <Testimonials />
      <HomesGallery />
      <Magazine />
      <TrophyCabinet />
      <InTheNews />
      <FAQSection />
      <DreamBanner />
    </div>
  );
}